var map = {
	"./contact/editInitialSchema": 916,
	"./cpo/editInitialSchema": 917,
	"./customer/editInitialSchema": 918,
	"./forwarderPo/editInitialSchema": 919,
	"./incomingInvoice/editInitialSchema": 920,
	"./incomingPayment/editInitialSchema": 921,
	"./outgoingInvoice/editInitialSchema": 922,
	"./outgoingPayment/editInitialSchema": 923,
	"./outgoingQuote/editInitialSchema": 924,
	"./product/editInitialSchema": 925,
	"./receiving/editInitialSchema": 926,
	"./shipping/editInitialSchema": 927,
	"./spo/editInitialSchema": 928,
	"./spoSched/editInitialSchema": 929,
	"./vatDeductRecord/editInitialSchema": 930,
	"./vendor/editInitialSchema": 931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 915;